define('controller/IndexController',['require','lib/controller/BaseController','view/controller/index/IndexView','model/CompanyModel'],function (require) {

	var BaseController = require('lib/controller/BaseController');
	var IndexView = require('view/controller/index/IndexView');
	var CompanyModel = require('model/CompanyModel');
	
	/**
	 * Index Controller
	 * 
	 * @class IndexController
	 */
	return BaseController.extend({
	
		_model: null,
		_view: null,
	
		/**
		 * index action, display index view in content region
		 */
		index: function() {
			this._index(false, false);
	    },

		map: function () {
            this._index(true, false);
		},

		about: function () {
            this._index(false, true);
		},

		_index: function (showOnMap, showAboutUs) {
            this._view = new IndexView({
                model: this._getModel(),
                showOnMap: showOnMap,
                showAboutUs: showAboutUs
            });

            this.getMainLayout().getContentRegion().show(this._view);
		},

	    /**
	     * instantiates and returns CompanyModel instance
	     * 
	     * @reurn CompanyModel
	     */
	    _getModel: function () {
	    	if (!this._model) {
	    		this._model = new CompanyModel();
	    		this._model.fetch();
	    	}
	    	return this._model;
	    }
	
	});
	
});
